export default __webpack_public_path__ + "8a4f352ab6e7837919ed4bdaee86ab97.svg";